{
    "coordinates": [
        -35.59573449710789,
        137.52176124100282
    ],
    "tooltip": "Emu Bay",
    "title": "Emu Bay Shale",
    "country": "Australia",
    "period": "Cambrian",
    "alt": "TODO"
}
